import { notification } from 'antd';
import { NotificationPlacement } from 'antd/lib/notification/interface';
import { useEffect } from 'react';

export const useNotifications = (
  successResult: boolean,
  errorResult: boolean,
  successResultMessage: string,
  errorResultMessage: string | undefined | null,
  reset: () => void,
  placement: NotificationPlacement | undefined = 'topRight',
) => {
  useEffect(() => {
    if (successResult) {
      notification.success({
        message: successResultMessage,
        placement,
      });
      reset();
    }
  }, [successResult, successResultMessage]);

  useEffect(() => {
    if (errorResult) {
      notification.error({
        message: errorResultMessage || 'Что-то пошло не так',
        placement,
      });
      reset();
    }
  }, [errorResult, errorResultMessage]);

  // useEffect(() => () => reset(), [reset]);
};
